import $ from 'jquery';

export default class UpArrow {
	constructor() {
		this.arrow = $('.up-arrow');
	}

	init() {
		$(window).on('scroll', () => {
			if ($(window).width() >= 1024 && $(window).scrollTop() > 0) {
				this.arrow.addClass('up-arrow_visible');
			}else {
				this.arrow.removeClass('up-arrow_visible');
			}
		});

		this.arrow.on('click', event => {
			event.preventDefault();

			$('html, body').animate({
				scrollTop: 0
			}, 400);
		});
	}
}



// WEBPACK FOOTER //
// ./app/blocks/up-arrow/index.js